import { RootState } from "redux/reducers/rootReducer";
import { createSelector } from "reselect";

const getSearchState = (state: RootState) => state.search;

export const getSearchLoading = createSelector(
  [getSearchState],
  (state) => state.loading
);

export const getSearchData = createSelector([getSearchState], (state) => {
  const { article, brand, dispensary, menuItem, strain } = state;
  return { article, brand, dispensary, menuItem, strain };
});

export const getSearchMenuItemCategories = createSelector(
  [getSearchState],
  (state) => state.menuItemCategories
);

export const getSearchMenuItemDispensaries = createSelector(
  [getSearchState],
  (state) => state.menuItemDispensaries
);

export const getSearchCategoryRelevanceOrder = createSelector(
  [getSearchState],
  (state) => state.categoryRelevanceOrder
);
